import React from "react";
import Footer from "../components/layout/Footer";
import Navbar from "../components/layout/Navbar";

function Customer() {
  return (
    <div class="main-container">
      <Navbar />
      <div class="signup-page col-12 col-lg-11 ml-lg-5">
        <div class="col-12 pricing-page">
          <div id="pricing">
            <div class="price-tag  col-lg-10 col-12 ml-auto mr-auto p-0 text-justify">
              <h3 class="text-center">CUSTOMER CODE OF PRACTICE</h3>
              <br />
              <ol>
                <li>
                  <p>
                    <b> OBLIGATIONS DU CONSOMMATEUR</b>
                    <br />
                    Les consommateurs de Tizeti (GhanaWifi) seront liés par nos
                    conditions de service en retournant un contrat de service
                    signé, ou en effectuant le paiement pour notre service ou en
                    acceptant clairement les conditions de service lors de leur
                    inscription sur notre site Web. Les consommateurs seront
                    également réputés accepter les conditions de service du
                    titulaire de licence au début de l'utilisation du service
                    qui suit la réception par Tizeti (GhanaWifi) de la
                    communication par courrier électronique d'inscription de nos
                    conditions de service. Les consommateurs accorderont au
                    titulaire de licence ou à ses représentants autorisés, sans
                    frais, l'accès aux locaux, équipements ou installations
                    raisonnablement requis pour toute fourniture ou maintenance
                    des services, équipements ou installations. Les
                    consommateurs n'utiliseront aucun équipement ou installation
                    connexe fourni par un titulaire de licence pour des raisons
                    autres que celles liées au service normal, <br /> Les
                    équipements appartenant à Tizeti (GhanaWifi) et connectés à
                    notre réseau Internet haut débit ne peuvent pas être
                    déplacés vers un emplacement ou une adresse autre que
                    l'emplacement ou l'adresse où le service a été installé,
                    sans l'autorisation écrite préalable de Tizeti (GhanaWifi).
                    <br />
                    La modification ou la fixation de tout appareil non autorisé
                    à l'équipement ou aux installations de Tizeti (GhanaWifi)
                    est interdite.
                    <br /> Aucun équipement ou appareil qui interfère de quelque
                    manière que ce soit avec le fonctionnement normal de notre
                    service, y compris tout équipement ou appareil qui
                    intercepte ou aide à intercepter ou à recevoir tout service
                    offert par le titulaire de licence nécessitant une
                    autorisation spéciale, ne peut être installé par ou au nom
                    de tout Consommateur.
                    <br /> Les consommateurs ne revendront aucun service fourni
                    par Tizeti (GhanaWifi), sauf dans la mesure permise par le
                    contrat de service du titulaire (et sous réserve de toute
                    licence ou autorisation applicable de la Commission en vertu
                    de la loi).
                    <br /> Les consommateurs n’utiliseront pas à mauvais escient
                    les services publics de télécommunications, notamment :
                    <br />
                    <ul>
                      <li>
                        en obtenant de manière malhonnête des services de
                        télécommunications ; ou
                      </li>
                      <li>
                        posséder ou fournir du matériel pouvant être utilisé
                        pour obtenir de tels services de manière malhonnête ou
                        frauduleuse ; ou
                      </li>
                      <li>
                        utiliser des services pour envoyer des messages
                        obscènes, menaçants ou autrement contraires aux lois ou
                        réglementations applicables.
                      </li>
                    </ul>
                  </p>
                </li>

                <br />
                <li>
                  <p>
                    <b>PROTECTION DES INFORMATIONS DES CONSOMMATEURS </b> <br />
                    Tizeti (GhanaWifi) peut collecter et conserver des
                    informations sur des consommateurs individuels
                    raisonnablement nécessaires à ses fins commerciales.
                    Cependant, la collecte et la conservation des informations
                    sur
                    <br /> les consommateurs individuels seront :
                    <br />
                    <ul>
                      <li>
                        collectés et traités équitablement et licitement ;
                      </li>
                      <li>traitées à des fins limitées et identifiées ;</li>
                      <li>pertinent et non excessif ;</li>
                      <li>précis ;</li>
                      <li>pas conservé plus longtemps que nécessaire ;</li>
                      <li>
                        traité conformément aux autres droits du Consommateur ;
                      </li>
                      <li>
                        protégé contre toute divulgation inappropriée ou
                        accidentelle ; et
                      </li>
                      <li>
                        ne sont transférés à aucune partie, sauf dans la mesure
                        permise par les termes et conditions convenus avec le
                        consommateur, dans la mesure permise par toute
                        autorisation ou approbation de la Commission, ou dans la
                        mesure permise ou requise par d'autres lois ou
                        réglementations applicables.
                      </li>
                    </ul>
                    <br />
                    <p>
                    Tizeti respectera les principes d'information équitable 
                    généralement acceptés, notamment:
                      <ul>
                        <li>
                        fournir un avis sur les informations individuelles du consommateur qu'ils collectent, 
                        ainsi que sur leur utilisation ou leur divulgation;
                        </li>
                        <li>
                        les choix dont disposent les consommateurs quant à la collecte, 
                        à l'utilisation et à la divulgation de ces informations;
                        </li>
                        <li>
                        l'accès des consommateurs à ces informations, notamment pour 
                        garantir leur exactitude; et
                        </li>
                        <li>
                        les mesures de sécurité prises pour protéger les informations, 
                        ainsi que les mécanismes d'application et de recours mis en place pour 
                        remédier à tout manquement à ces mesures.
                        </li>
                      </ul>
                      <br /> Ces règles s'appliquent aux informations individuelles du consommateur, 
                      qu'elles soient initialement fournies verbalement ou sous forme écrite, à condition que ces 
                      informations soient conservées par le titulaire de licence sous quelque forme enregistrée. 
                      Le système de gestion des relations avec les consommateurs de Tizeti sera utilisé pour collecter et protéger les 
                      informations et garantira que tout autre Tizeti ou toute autre personne avec laquelle ils 
                      échangent ou divulguent de toute autre manière ces informations ont adopté et mis en œuvre une politique appropriée 
                      de protection des informations sur les consommateurs.
                      <br />
                    </p>
                    <p>
                    La politique de Tizeti sur la protection des informations des consommateurs sera mise à disposition de manière accessible 
                    et facile à lire dans nos bureaux et sur notre site Web. La politique:
                      <br />
                      <ul>
                        <li>
                        indiquer clairement quelles informations sont collectées ; l'utilisation de ces informations; 
                        un éventuel échange ou divulgation par des tiers de ces informations ; et les choix qui s'offrent au 
                        Consommateur concernant la collecte, l'utilisation et la divulgation des informations collectées.
                        </li>
                        <li>
                        divulguer les conséquences, le cas échéant, 
                        du refus d'un consommateur de fournir des informations.
                        </li>
                        <li>
                        inclure une déclaration claire sur la manière de contacter le titulaire de licence 
                        concernant les problèmes d'information et les mécanismes d'accès à l'information 
                        ou de plainte connexes.
                        </li>
                      </ul>
                      <br /> Dans le cadre de la collecte, du maintien, de l'utilisation ou de la divulgation 
                      par Tizeti des informations identifiables individuellement sur les consommateurs, Tizeti 
                      prendra des mesures raisonnables pour garantir que les informations sont exactes, 
                      pertinentes et à jour aux fins pour lesquelles elles doivent être utilisées.
                      
                    </p>
                  </p>
                </li>

                <br />

                <li>
                  <p>
                    {" "}
                    <b>TRAITEMENT DES PLAINTES</b>
                    <br /> Les consommateurs de Tizeti (GhanaWifi) peuvent
                    déposer une plainte par
                    <br />
                    Telephone : 0308250074
                    <br /> Email: internet@ghanawifi.com
                    <br /> Le consommateur peut également déposer une plainte dans l'un de nos locaux.
                    <br /> Toutes les plaintes seront enregistrées par Tizeti.
                    <br /> Tizeti prendra les dispositions adéquates pour assurer que les personnes ayant un 
                    handicap physique ou d'autres besoins spéciaux puissent accéder à nos processus de traitement 
                    des plaintes, notamment en veillant à ce que les consommateurs puissent être facilement représentés 
                    par leurs représentants autorisés afin de déposer une plainte.
                    <br /> Dans les cas où les consommateurs demandent spécifiquement de l'aide pour déposer une plainte, 
                    Tizeti fournira une assistance raisonnable.
                  </p>
                </li>

                <p>
                Les plaintes écrites seront reconnues par Tizeti et traitées dans les délais fixés 
                dans le Règlement sur la qualité du service de 
                la Commission (ou selon les directives de la Commission de temps à autre). 
                Tizeti répondra dans un premier temps à une plainte verbalement ou par écrit.
                  <br /> Les réclamations non écrites seront considérées comme reconnues par Tizeti 
                  au moment où la réclamation a été communiquée à Tizeti.
                  <br />
                  Dans la mesure du possible, les consommateurs seront informés, lorsqu'ils déposent une plainte, 
                  des actions attendues et du calendrier d'enquête et de résolution des plaintes. 
                  Dans le cas où le Licencié considère la plainte comme frivole ou vexatoire, 
                  le Consommateur en sera informé en conséquence et s'il n'est pas satisfait, 
                  le Consommateur aura le recours supplémentaire décrit ci-dessous. En tout état de cause, 
                  aucune réclamation du Consommateur ne restera sans réponse plus de trois (3) mois.
                  <br /> Tizeti fournira aux Consommateurs suffisamment d'informations et les moyens de se 
                  renseigner sur l'évolution des réclamations en utilisant leur numéro de ticket d'assistance. 
                  Ces processus peuvent inclure des numéros de référence de plainte ou d’autres identifiants afin de 
                  faciliter des réponses rapides et précises aux demandes ultérieures des consommateurs.
                  <br />
                  Les consommateurs seront informés du résultat de l'enquête relative à leur plainte et de toute 
                  décision résultante du titulaire de licence.
                  <br /> Lorsqu'un consommateur n'est pas satisfait d'une décision prise à la suite d'une plainte, 
                  le titulaire de licence donnera au consommateur la possibilité de suivre un processus de remontée 
                  d'informations identifié par lequel la décision pourra être examinée par une personne 
                  dûment qualifiée au sein de l'organisation du titulaire de licence. 
                  Lorsque le Consommateur a déjà bénéficié du ou des processus de remontée d'informations 
                  du Licencié et qu'il n'y a pas d'autres processus de remontée d'informations, le Licencié en 
                  informera le Consommateur en conséquence.
                  <br /> Dans le cas où une plainte n'aurait pas été résolue à la satisfaction du Consommateur, 
                  y compris à la suite d'un processus d'escalade, dans les soixante (60) jours suivant sa 
                  communication au Licencié, le Licencié informera le Consommateur qu'il peut référer 
                  le plainte à la Commission.
                  <br /> Le non-respect des plaintes des consommateurs et toute défaillance de service associée 
                  seront également soumis aux exigences des réglementations sur la qualité du service, 
                  y compris le paiement de tout crédit de service spécifique ou remise établi conformément à ces 
                  réglementations.
                  <br /> Les processus de traitement des plaintes seront fournis gratuitement. Tizeti imposera des frais raisonnables 
                  pour les processus de traitement des plaintes lorsque l'enquête sur la plainte nécessite 
                  la récupération de dossiers datant de plus de douze (12) mois, et lorsque cette récupération 
                  entraîne des dépenses supplémentaires ou des inconvénients importants pour le titulaire de licence. 
                  Tous ces frais seront identifiés et acceptés par le consommateur avant d'être engagés.
                  <br /> Tizeti évitera d'imposer toute déconnexion ou mesure de gestion du crédit concernant tout service auquel 
                  se rapporte une plainte ou un litige de facturation pendant que la plainte ou le litige fait l'objet d'une enquête. 
                  Le Licencié informera le Consommateur que, pendant que la plainte ou le litige est en cours 
                  d'examen, le Consommateur est tenu de payer tous les montants impayés autres que le montant spécifiquement 
                  litigieux. Lorsque Tizeti a l'intention d'entreprendre une action de déconnexion ou de gestion 
                  de crédit à l'encontre d'un Consommateur concernant tout montant ayant fait l'objet d'une plainte ou d'un litige, 
                  le Licencié en informera spécifiquement le Consommateur avant d'entreprendre l'action envisagée.
                  <br /> Le système de support Tizeti doit disposer de systèmes d'enregistrement appropriés pour les plaintes et leurs 
                  résultats afin de répondre aux exigences de la quantité du Règlement de service.
                  <br /> Les données de suivi des réclamations seront catégorisées et analysées par Tizeti de temps à autre pour permettre 
                  l'identification de problèmes récurrents. Tizeti informera le Consommateur qu'un enregistrement de ses réclamations est conservé et, 
                  si le Consommateur le demande, décrira les réclamations, le suivi. système que nous utilisons.
                </p>

                <p>
                Tizeti utilisera son système de tickets d'assistance pour enregistrer les plaintes et leurs résultats 
                afin de répondre aux exigences de la quantité du Règlement de service.
                  <br /> Tizeti mettra à jour toutes les informations concernant ses processus de traitement et de suivi des plaintes, 
                  le cas échéant, y compris les informations fournies aux consommateurs ou à la Commission.
                  <br /> Les informations collectées et enregistrées dans le cadre des processus de traitement des plaintes de Tizeti 
                  seront conservées par Tizeti pendant au moins douze (12) mois après la résolution d'une plainte.
                </p>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Customer;
